export const trimUrlSlashes: (url: string) => string = (url: string) => {
  for (let prefix of ["http://", "https://", "ftp://"]) {
    if (url.indexOf(prefix) > -1) {
      return prefix + trimUrlSlashes(url.split(prefix)[1]);
    }
  }
  return url.replace(/\/\//g, "/");
};
